import { Button } from "@newsela/angelou";
import { Interpolation, Theme } from "@emotion/react";
import { DATAGRAIL_LOADER_URL } from "@/datagrailIntegration/config";
import { showConsentBanner } from "@/datagrailIntegration/dgBannerApi";

import { buttonCss } from "./PrivacyPreferencesButton.style";

interface PrivacyPreferencesButtonProps {
  cssOverride?: Interpolation<Theme>;
}

const PrivacyPreferencesButton = ({
  cssOverride,
}: PrivacyPreferencesButtonProps) => {
  if (!DATAGRAIL_LOADER_URL) {
    return null;
  }

  return (
    <Button
      type="button"
      flavor="INCOGNITO"
      __cssFor={{ root: cssOverride ?? buttonCss }}
      onClick={showConsentBanner}
      data-qa-selector="privacy-preferences"
    >
      Privacy Preferences
    </Button>
  );
};

export default PrivacyPreferencesButton;
